import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { IUser } from 'src/modules/authentication/interfaces/user.interface';
import { OnBoardingStafferService } from '../../services/onboarding-staffer.service';
import { LoadingService } from 'src/modules/shared/services/loading.service';
import { select, Store } from '@ngrx/store';
import { IAuthState } from 'src/modules/authentication/+store/auth.state';
import { getUserInfo } from 'src/modules/authentication/+store/auth-selector';
import { take } from 'rxjs/operators';
import { SkillFilterationService } from 'src/modules/shared/services/skill-filteration.service';
import { UserService } from 'src/modules/shared/services/user.service';
import { IdVerificationStatusEnum } from 'src/modules/onboarding-company/enums/id-verification-status.enum';
import { PopupService } from 'src/modules/shared/services/popup.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-submit-for-approval-success',
  templateUrl: './submit-for-approval-success.component.html',
  styleUrls: ['./submit-for-approval-success.component.scss']
})
export class SubmitForApprovalSuccessComponent implements OnInit {
  @Input() data: {
    message: string;
    btn: string;
    navigateRoute: string;
    imgURL?: string;
  };
  user: IUser;
  isLoading = false;

  constructor(
    private modalController: ModalController,
    private router: Router,
    private onBoardingStafferService: OnBoardingStafferService,
    private loadingService: LoadingService,
    private popupService: PopupService,
    private store: Store<IAuthState>,
    private skillFilterationService: SkillFilterationService,
    private userService: UserService,
  ) {}

  async ngOnInit() {
    try {
      this.isLoading = true;
      const user = await this.userService.getUser();
      this.user = user;
    } finally {
      this.isLoading = false;
    }
  }

  get isIdVerificationStatusPending() {
    if (!environment.CREDENTIALS_ENABLED) return false;
    return this.user?.idVerificationStatus === IdVerificationStatusEnum.PENDING;
  }

  dismissPopup() {
    this.modalController.dismiss();
  }

  async requestIdVerification() {
    const loading = await this.loadingService.showLoading().toPromise();
    try {
      await this.onBoardingStafferService.requestIdVerification().toPromise();
      this.showIdVerificationPopup();
    } catch (err) {
      console.log(err);
    } finally {
      this.loadingService.hideLoading(loading);
    }
  }

  showIdVerificationPopup() {
    this.modalController.dismiss();
    
    this.popupService.showModal({
      heading: 'Success',
      message: 'Your ID verification request has been submitted successfully. Please check your email.',
      btn: 'OK',
      imgURL: 'assets/images/tick-mark.png', 
      navigateRoute: this.data.navigateRoute || 'talent-dashboard/home'    
    })
    
  }

  navigateToHome() {
    this.modalController.dismiss();
    console.log('received pending status!');
    this.router.navigateByUrl(this.data.navigateRoute || 'talent-dashboard/home');
  }
}
